import React from 'react';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import { BeforeRenderModalTexts } from 'reactApp/ui/BeforeRenewModal/BeforeRenewModal.helpers';

import styles from './BeforeRenewModal.css';

export interface BeforeRenewModalProps {
    onClose?(): void;
    onClick?(): void;
    onCancel?(): void;
    onShow?(): void;
    subscription: BillingDataSubscriptionInfo;
}

export function BeforeRenewModal({ onShow, onCancel, onClick, onClose, subscription }: BeforeRenewModalProps) {
    return (
        <BaseConfirmDialog
            dataQAId="before-renew-modal"
            className={styles.dialog}
            onSuccess={onClick}
            onAction={onCancel}
            onShow={onShow}
            onClose={onClose}
            renderHeader={() => (
                <span className={styles.title}>
                    {BeforeRenderModalTexts.getTitle(subscription)}
                    <br />
                    {BeforeRenderModalTexts.getTitleQuestion(subscription)}
                </span>
            )}
            renderContent={() => (
                <span className={styles.content}>
                    {BeforeRenderModalTexts.getContentText(subscription)}
                    <br />
                    {BeforeRenderModalTexts.getContentRenewalText(subscription)}
                </span>
            )}
            size="average"
            buttonTheme="vk"
            buttons={[EButtonType.accept, EButtonType.action]}
            successButtonText="Продлить"
            actionButtonText="Не продлевать"
        />
    );
}
